export default "__VITE_ASSET__Bybenuw2__"